<template>
    <Row type="form-row">
        <InputBox
                :title="priceLabel"
                :title2="priceLabel2"
                :model-form="modelForm"
                :model-name="modelName"
                :no-margin-top="true"
                :errors="errors"
                :inputFunction="input"
                type="number"
                :sm-size="smSize"
        />

        <SelectBox
                :after-fetch="afterFetchCurrencies"
                :errors="errors"
                :model-form="modelForm"
                :model-name="currencyModelName"
                :no-margin-top="false"
                check-to-model="modelNumberState"
                getter-name="getCurrencies"
                fetch-name="fetchCurrencies"
                text-field="shortName"
                :sm-size="smSize"
                label="currency"
                :margin-bottom="marginBottom"
                :label-style="labelStyle"
        />

    </Row>
</template>

<script>
    import validatorMixin from "../mixin/validatorMixin";
    import {mapActions, mapGetters} from "vuex";
    import Row from "./html/Row";
    import SelectBox from "./SelectBox";
    import InputBox from "./InputBox";

    export default {
        name: "PricePerUnit",
        components: {InputBox, SelectBox, Row},
        mixins: [validatorMixin],
        computed: {
            ...mapGetters(['getCurrencies']),
        },
        methods: {
            ...mapActions(['fetchCurrencies']),
            afterFetchCurrencies() {
                if (this.modelForm[this.currencyModelName] === 0) {
                    this.modelForm[this.currencyModelName] = 3 // todo from company settings
                }
            },
        },
        props: {
            modelForm: {
                type: Object,
                required: true,
            },
            errors: {
                type: Object,
                required: true,
            },
            priceLabel: {
                type: String,
                default: " ",
            },
            priceLabel2: {
                type: String,
                default: " ",
            },

            // optional
            modelName: {
                type: String,
                default: "bulkPrice",
            },
            currencyModelName: {
                type: String,
                default: "currencyId",
            },
            input: {
                type: Function,
                default: function () {
                },
            },
            smSize: {
                type: String,
                default: '5'
            },
            labelStyle: {
                type: String,
                default: '',
            },
            marginBottom: {
                type: String,
                default: '',
            }
        },
    }
</script>
